<template lang="html">

  <section class="otros-lugares animation">


    <div class="lugares-list row-center container">

      <h2 class="title -ghost container" v-html="$t('otros_lugares.titulo')"></h2>

      <template v-for="(el, key) in $t('otros_lugares.lugares')">

        <article :data="key" class="lugar-el row-center plum-border" v-if="key != urlName">
          <router-link :to="$t(`enlaces.${[key]}`)" class="enlace-cover"></router-link>
          <router-link :to="$t(`enlaces.${[key]}`)" class="btn"><span>{{el}}</span></router-link>
        </article>

      </template>

    </div>

  </section>

</template>

<script lang="js">
  export default  {
    name: 'otros-lugares',
    computed : {
      urlName : function(){
        return this.$route.name;
      }
    }
  }
</script>

<style scoped lang="scss">

@import "@/assets/css/colors.scss";


.otros-lugares {
  background: $plum;
  padding: 50px 0;
}

.lugares-list{
  position: relative;
  margin-top: 48px;
  display:flex;
  flex-wrap: nowrap;
}

.title.-ghost{
  position: absolute;
  right: 0;
  top: -60px;
  text-align: right;
  line-height: 1em;
  margin-bottom: 0;
  padding-bottom: 0;
  transform: translateY(50px);
  opacity: 0;
  transition: 1s;
  transition-delay: 2s;
}

.lugar-el{
  width: 50%;
  height: calc(#{$container-width} / 4);
  position: relative;
  z-index: 2;
  opacity: 0;
  transition: 1s;
}

@for $i from 1 through 9{
  .lugar-el:nth-child(#{$i}){
    transition-delay: #{$i / 7 + .2}s;
  }
}

.lugar-el[data=la_tierra]{
  background: url(/static/img/lugar-la-tierra.jpg) center/cover no-repeat;
}

.lugar-el[data=la_bodega]{
  background: url(/static/img/lugar-bodega.jpg) center/cover no-repeat;
}
.lugar-el[data=la_almanzara]{
  background: url(/static/img/lugar-almanzara.jpg) center/cover no-repeat;
}
.lugar-el[data=sala_azafran]{
  background: url(/static/img/lugar-sala-azafran.jpg) center/cover no-repeat;
}
.lugar-el[data=queseria]{
  background: url(/static/img/otros-lugares-queseria.jpg) center/cover no-repeat;
}

.launched {
  .title.-ghost{
    transform: translateY(0);
    opacity: .5;
  }
  .lugar-el{
    opacity: 1;
    .btn{
      transform: translateY(0);
      opacity: 1;
    }
  }
}

@media screen and (max-width: 1200px){
  .lugares-list{
    padding-bottom: 25px;
    display:flex;
  flex-wrap: nowrap;
  }
  .lugar-el{
    height: 33vw;
  }
}

@media screen and (max-width: 769px){
  .lugar-el{
    height: 25vh;
    width: 100%;
  }
}

@media screen and (max-width: 600px){
  .lugares-list{
    padding: 0;
    background: $plum;
    display:flex;
  flex-wrap: wrap;
    margin-top: 0;
    padding-top: 50px;
    .title.-ghost{
      top: 27px;
    }
  }
  .otros-lugares{
    padding-top: 0;
    padding-bottom: 0;
  }

  .lugar-el{
    width: 100%;
    height: 33.333vh;
  }
}


</style>



// WEBPACK FOOTER //
// src/components/parts/otros-lugares.vue